import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

import { brandFocusRing } from './shared'

const baseStyle = (props: StyleFunctionProps) => {
  const focusRing = brandFocusRing(props)
  return {
    borderWidth: '1px',
    borderRadius: 'lg',
    p: '4',
    bg: 'bg-surface',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _hover: { borderColor: mode('gray.300', 'gray.600')(props) },
    _checked: focusRing,
    _focusVisible: focusRing,
  }
}

export default {
  baseStyle,
}
